<template lang="pug">
    v-content
      NavbarLogin
      LoginCard
    //- v-content
    //-     v-container.bg(fluid fill-height)
    //-         v-layout(align-center justify-center)
    //-             v-flex(xs12 sm8 md6 lg4)
    //-                 LoginCard
    //-     Landing
</template>

<script>
import Landing from "../components/Landing.vue";
import LoginCard from "../components/LoginCard.vue";
import NavbarLogin from "../components/NavbarLogin.vue";
export default {
  components: {
    Landing,
    LoginCard,
    NavbarLogin
  }
};
</script>

<style>
.bg {
 /* background: url("../assets/bliss.jpg");*/
  background-size: cover;
}
</style>

